// generate images component
// ng g c shared/components/images/imageName -is --spec false

import { ImageSignupComponent } from './image-signup/image-signup.component';

export const Images = [ImageSignupComponent];
